<div>
  <app-list-featured-filter></app-list-featured-filter>
</div>
<div class="list">
  <div class="list-header">
    <div class="list-header-sort">
      <app-list-sort></app-list-sort>
    </div>
    <div class="list-header-actions">
      <ng-container *ngIf="isLoading()">
        <div class="spinner">
        <mat-spinner diameter="20"></mat-spinner>
        </div>
      </ng-container>
      <ng-container *ngIf="!isLoading()">
        <button mat-icon-button color="accent" aria-label="Reload list" i18n-aria-label (click)="onReload()">
          <mat-icon aria-hidden="false">cached</mat-icon>
        </button>
        <eas-export-button *ngIf="supportExport"></eas-export-button>
      </ng-container>
      <!-- /Reload control -->
    </div>
  </div>

  <ng-container [ngSwitch]="state.type">
    <ub-box *ngSwitchCase="'loading'" rounded="true">
        <div content i18n>
          Items are loading please wait...
        </div>
    </ub-box>
    <ub-box *ngSwitchCase="'empty'" rounded="true">
      <div content i18n>
        There are no items in this list.
      </div>
    </ub-box>
    <ng-container *ngSwitchCase="'full'">
      <ng-container i18n>Found {{ list.totalCount$ | async }} items</ng-container>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="pageSizeControl">
          <mat-option *ngFor="let option of pageSizeOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <eas-table
        [table]="list.table | async"
        [canSelectColumns]="true"
        [selectedColumnsStorageKey]="'booking-item-option-view'"
      ></eas-table>
    </ng-container>
    <ub-alert variant="danger" *ngSwitchCase="'error'">
      <ng-container i18n>We are unable to load items for this list due to error.</ng-container>
      <pre>{{ state.error?.message }}</pre>
    </ub-alert>
  </ng-container>

  <app-list-paginator *ngIf="isLoadedWithItems()"></app-list-paginator>
</div>
<aside>
  <app-list-filter fxFlex="1 1 0%"></app-list-filter>
</aside>
